import { defineStore } from 'pinia';
import { MenuState, IMenuItem } from './type';
import { uniq } from 'lodash-es';
import { userFindMenuTree } from '@/api/uacs/user';
import { IUserFindMenuTreeResKeyItem } from '@/api/uacs/user/types';
import { TYPE_ENUM as MENU_TYPE_ENUM } from '@/api/uacs/menu/constant';
import { parse } from 'qs';
import { CURRENT_CLIENT_CODE } from '@/constant';
import { RouteLocationNormalized } from 'vue-router';
import { useAccountStore } from '@/store/account';

// 首页路由配置
const BASE_ROUTE: IUserFindMenuTreeResKeyItem[] = [
  {
    id: '-1',
    componentName: 'Home',
    name: '首页',
    type: MENU_TYPE_ENUM.MENU,
    icon: 'font_family icon-shouye1',
  },
];

export const useMenuStore = defineStore({
  id: 'menu',
  state: (): MenuState => ({
    menus: [],
    isGetMenu: false,
    authMenuList: ['SelectTenant'],
    authButtonList: [],
    flatMenus: [],
    activeMenu: '',
  }),

  actions: {
    async getMenus() {
      if (this.isGetMenu) return;

      const { data } = await userFindMenuTree([CURRENT_CLIENT_CODE]);
      const resourceTreeVos: IMenuItem[] = [...BASE_ROUTE];
      Object.keys(data).forEach((key) => {
        resourceTreeVos.push(...data[key]);
      });
      // 这里判断，如果是超级管理员，则添加默认路由
      const { account } = useAccountStore();
      const authMenuList: string[] = ['Home', 'SelectTenant'];
      const authButtonList: string[] = [];
      const flatMenus: IMenuItem[] = [];
      const deep = (menuTree: IMenuItem[], parentId: string = '-1'): IMenuItem[] => {
        return menuTree.map((it) => {
          const row = {
            ...it,
            parentId,
          } as IMenuItem;
          let path = row.componentName || row.url;
          if (row.type === MENU_TYPE_ENUM.MENU) {
            if (path) {
              if (path.includes('?')) {
                const [routeName, search] = path.split('?');
                path = routeName;
                row.componentName = path;
                row.query = parse(search) as unknown as any;
              }
              authMenuList.push(path);
            }
            flatMenus.push(row);
          }
          if (row.children?.length && row.type === MENU_TYPE_ENUM.MENU) {
            row.children = deep(row.children, row.id);
          } else if (row.type === MENU_TYPE_ENUM.BUTTON) {
            if (path) {
              authMenuList.push(...path.split(','));
            }
          }
          if (row.code) {
            authButtonList.push(row.code);
          }
          return row;
        });
      };
      this.menus = deep(resourceTreeVos);
      this.flatMenus = flatMenus;
      this.authMenuList = uniq(authMenuList);
      this.authButtonList = uniq(authButtonList);
      this.isGetMenu = true;
    },
    clearMenus() {
      this.menus = [...BASE_ROUTE];
      this.authMenuList = ['SelectTenant'];
      this.authButtonList = [];
      this.flatMenus = [];
      this.isGetMenu = false;
    },
    setActiveMenu(menu: string) {
      this.activeMenu = menu;
    },

    hasPermission(code: string): boolean {
      if (process.env.NODE_ENV === 'development') {
        return true;
      }
      return this.authButtonList.includes(code);
    },

    hasMenu(route: RouteLocationNormalized) {
      if (process.env.NODE_ENV === 'development') {
        return true;
      }
      return this.authMenuList.includes(route.name as string);
    },
  },
});
